export default {
  banner_prefix:
    'Promo codes work everywhere else today — this one-time step turns them on for your ',
  banner_provider: 'Olo',
  banner_suffix:
    ' online ordering. Olo estimates enablement takes about 10–14 weeks.',
  title: 'Activate promo codes on Olo',
  body: 'Olo requires a one-time opt-in from your brand before Thanx promo codes can be accepted on Olo-powered ordering. Send the email below to your Olo account representative to get started.',
  steps: {
    copy: {
      title: 'Copy the note below',
      body: 'It already includes your Thanx Client ID, so your rep has everything they need.',
    },
    email: {
      title: 'Email it to your Olo representative',
      body_prefix: 'CC',
      body_suffix: 'so our team knows the request is in flight.',
    },
    handoff: {
      title: 'Work with Olo to enable Thanx as your coupon code provider',
      body: 'Olo will work with you to transition coupon code handling to Thanx. Note: Olo tells us this can take 10–14 weeks.',
    },
  },
  email: {
    title: 'Email template for your Olo rep',
    to_label: 'To',
    to: 'Your Olo account representative',
    cc_label: 'Cc',
    subject_label: 'Subject',
    subject: 'Enable Thanx promo codes on Olo — %{brand}',
    greeting: 'Hi team,',
    body_intro:
      'We would like to use Thanx as our Olo coupon code provider. My Client ID on Thanx is:',
    client_id_label: 'Thanx client ID',
    body_outro:
      'I’ve CC’d the Thanx success team, who needs to be informed once you’ve completed this for me.',
    sign_off: 'Thanks!',
    copy: 'Copy email',
    open: 'Open in email',
    copy_success: 'Email copied to clipboard',
    copy_error: 'Could not copy the email. Please copy it manually.',
    missing_client_id:
      'We couldn’t find your Thanx client ID. Contact success@thanx.com and we’ll send the request for you.',
  },
  footer_prefix: 'Keep ',
  footer_email: 'success@thanx.com',
  footer_suffix:
    ' cc’d throughout. Thanx must enable our side after Olo enables theirs — this tab disappears once promo codes are live on Olo.',
}
